import { useEffect } from 'react'
import { Tooltip } from 'antd'

import { useValue } from '@hooks/useValue'
import { useDeviceType } from '@hooks/useDeviceType'

import { ICardApplicationUI } from './types'

import { IconClearClose, IconHelp, IconLogs, IconMainGrid } from '@img/icons'
import logoYaSkill from '@img/logo_yaskill.svg'
import logoModSkill from '@img/logo_modskill.svg'
import { Button, Divider, Drawer, Flex, Loader, Tab } from '@ui/index'

import css from './ui.module.scss'


/** UI - Анкета заявки */
export const CardApplicationUI = ({ 
    isOpen, cardMode, tabActive, isLoading, isDisableBtnSave,
    applicationDbName, applicationIsRepeat, applicationNumber, applicationDateCreate, applicationOrigin,
    getCardPage, handleOpenModalConfirm, handleOpenModalMailings,
    handleBtnSave, handleBtnClose 
}: ICardApplicationUI) => {
    const deviceType = useDeviceType()
    const originLabel = applicationOrigin?.trim()
    const siteLogo = applicationDbName === 'yaskill'
        ? {src: logoYaSkill, name: 'YaSkill'}
        : applicationDbName === 'modern_academy'
            ? {src: logoModSkill, name: 'ModSkill'}
            : null

    const toolTipVisible = useValue<boolean>(true)

    useEffect(() => {
        if (deviceType !== 'desktop') toolTipVisible.setValue(false)
    }, [deviceType, toolTipVisible])

    /** Получение кнопочной панели в зависимости от выбранной вкладки */
    const getCardPageBtnPanel = (tabActive: string) => {
        switch (tabActive) {
            case 'primary': {
                return <>
                    <Flex gap='4px'>
                        <Divider />
                        <Flex flexWrap='wrap' flexDirection='row' gap='4px'>
                            <Flex flexDirection='row' gap='4px' isRendered={cardMode === 'edit'} className='mobile550'>
                                <Button flexGrow={1} variant='primaryDark' padding='0 10px' onClick={() => handleOpenModalConfirm(true, 'Демо-доступ...', 'Вы действительно хотите создать демо-доступ, для данного клиента?')}>Демо-доступ</Button>
                                <Button flexGrow={1} variant='primaryDark' padding='0 10px' onClick={() => handleOpenModalMailings(true)}>Рассылки</Button>
                                <Divider id='hiddenFor550' type='vertical' margin='8px' />
                            </Flex>

                            <Flex flexDirection='row' gap='4px' className='mobile550'>
                                <Button flexGrow={1} padding='0 10px' isDisabled={isDisableBtnSave.value || isLoading} onClick={() => handleBtnSave(true)}>Сохранить и закрыть</Button>
                                <Button flexGrow={1} padding='0 10px' isDisabled={isDisableBtnSave.value || isLoading} onClick={() => handleBtnSave(false)}>Сохранить</Button>
                            </Flex>
                        </Flex>
                    </Flex>
                </>
            }
        }
    }

    return <>
        <Drawer isOpen={isOpen} placement='bottom' size='99.4%'>
            <Flex className='drawer_container'>
                <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                    <header style={{minWidth: 0, flex: 1}}>
                        <Flex gap='6px' flexDirection='row' alignItems='center'>
                            {siteLogo && <img className={css['header_logo']} src={siteLogo.src} alt={`Логотип ${siteLogo.name}`} />}
                            <h4 style={{minWidth: 0, overflowWrap: 'anywhere'}}>
                                {cardMode === 'edit' ? <>Анкета заявки{originLabel && ` (${originLabel})`}</> : 'Создание заявки'}
                            </h4>
                            
                            {applicationIsRepeat.value === 1 && 
                                <Tooltip placement="bottomRight" title={`${toolTipVisible ? 'Клиент требует внимания' : null }`}>
                                    <div style={{cursor: 'help'}}>🔥</div>
                                </Tooltip>
                            }
                        </Flex>

                        {cardMode === 'edit' && <h5>№ {applicationNumber.value} от {applicationDateCreate.value}</h5>}
                    </header>

                    <Button variant='icon' size='md' isDisabled={isLoading} onClick={handleBtnClose}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Flex gap='4px' className='drawer_container-body_bottom_panel'>
                    <Flex gap='6px' className='drawer_container-content'>
                        {getCardPage(tabActive.value)}
                    </Flex>

                    {getCardPageBtnPanel(tabActive.value)}
                </Flex>

                <Tab.Container isVisible={cardMode === 'edit'}>
                    <Tab.Item tabName='primary' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Основные данные' onClick={tabActive.setValue}><IconMainGrid /></Tab.Item>
                    <Tab.Item tabName='help' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Информация для оператора' onClick={tabActive.setValue}><IconHelp /></Tab.Item>
                    <Tab.Item tabName='logs' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Журнал изменений' onClick={tabActive.setValue}><IconLogs /></Tab.Item>
                </Tab.Container>

                <Loader isOpen={isLoading} title='Загрузка анкеты...' backdrop />
            </Flex>
        </Drawer>
    </>
}
